import React from "react";
import { Link } from "react-router-dom";
export default function LoginError() {
  return (
    <>
      <Link to="/auth">Kembali ke Login</Link>
    </>
  );
}
